var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.1796,
    height: 22.7573,
    fill: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.84467,
    y: 2.84465,
    width: 17.068,
    height: 17.068,
    fill: "url(#pattern0_25_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_25_19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_25_19",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_25_19",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAERklEQVR4nO2ZW4hWVRTHz0yWpviUWlOooYVpD4ZJZtlNvLwkEmaTFJEoElgYPahEatSDaWKYBiUmYiWCFqkvRip5IYrMS2CaRiBKKYqWUnkZ+8Ua/geXZ845c86c7zszxfd/mZmz13Wvtddae08Q1FBDDTXUUGEAPYFXgT3AZeAb4I7gvwLgXmAVcIGW2BJ0ZAA3AJOAr53RV4CNwFjgTn07G3REALcAc4FfnQNngEVAP0c3SGs/Bx0JwH3AR8BF58APwDSgawy9RcvweftY3DJ9JgJfRtJnEzAKqEvhfVv0c8u1+lojbgZmAcecA78DS4DbM8rYIr5x1be4pfJhwMeR9NkPTAVuTKDfB2yLWTsl/t5lps8zwLfO+CZgPfBIAk8X4C3RGb6LrPfR91PtnT59U/gsCj86Htv5/hGa8Vr7ouz0sfSYEpc+KVEw/A3cH0M7r3kVFlSr+uwiZ/VJiILhH0vJBPoNzRTQWMnm9TrwG1dxWjvbJwN/NAo2P4WYk8J3VDQDKjH7fKDQhzgIzIhrXhmiEI4etgmGtUlRBG4SzXmgvvT0SYnCEWCMJlnDTqBzCv9o0e0qpfpkjIJFtZsiYPgF6NWKjJmiXZpV6YCY2SexeeWMgjkzTGsL3GB4VwZZa0Q/JYvi8c4BU/4p8Gge4xOi0CSHumjNSrLhEjAyo7yD4hmShTisCu9nqT55o6D1kXIg2+4GzTzdlJIX086RZzgpBa/ZIa9kFFzaWioZFuaQ+4B49mZleMWdC1P4oarFdUWiIJoeqlSGz/KUUGC6+FYGOZie1WjhYZF6D3g4akBrURBNZ2CHaHZbqmQ2KGjmXyHel/LwhcwD1b3DQxbiOLAYeDAShQPRKEhOHbBaNFbKb22DLd+Lf0RuRyKC7pZThyNOJUbB8c5xHfmeNjbkCzrs3Qs5EpNKi2WYYWIKbaOGwKa23uiAwdLzUyHDUxTYe5NhVsL6UOBP0bxcQM9kyVhbyOAUBROSZh+7fwMntL6ioJ530zasMCxflbuWNj0ia3ul/CugU0E9OyRrbGGjU5RslpLn3Lf+rhD8ZSN+Afn1wDnJSh0qC8E1qnXumz04GP5wDq3K2zsM7nn0eFBN2DgvRefCkQZYpm+zgefdgT+Q92YHPCXeTVVzwikLp4Ax+ts6N+GTj1UsFxmL0oQcsueL741q+hAqe1PKltp1V/fvy5pYn3aT7iH9tL6yMEsR4OoZfKKsR2h0BXhMv1tUXlA3RrfKOj1Mh/ed7faI0YrsE6LtW4Yj9e415RP9PO12f2aE/iH3rwOb24YnyL3NTeGZ3gUq4cxyKQ0jgPrL1AT6BtcfLEIvxtA8rvWtpTghpTYJe1ijfLIVnuuBdxyPvRN0jRk2F5XiRMydwd5sR+fga3QD6H4NiQ2uOEyqruXJT0htuSIPirn3oFEn18tNu0Oz2zJVv5MqHA3tbVcNNQT/E/wLtlaeRcNmVAgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.f1e42c9ef1c30218112a2d0c5654d8a8.svg";
export { ForwardRef as ReactComponent };